import React from "react";

import { useQuery, useMutation } from "@apollo/client";

import { genreListQuery, deleteGenreMutation } from "graphql/genre";

import BaseList from "./BaseList";

function GenreList() {
  const { data: { genreList = [] } = {} } = useQuery(genreListQuery);

  const [deleteRow] = useMutation(deleteGenreMutation, {
    update(cache, result) {
      const data = cache.readQuery({ query: genreListQuery });
      const nextData = {
        genreList: data.genreList.filter(
          (genre) => genre.id !== result.data.deleteGenre.id
        ),
      };
      cache.writeQuery({
        query: genreListQuery,
        data: nextData,
      });
    },
  });

  const columns = [
    {
      header: "Name",
      body: (item) => item.name,
    },
    {
      header: "Abbreviation",
      body: (item) => item.abbreviation,
    },
  ];

  return (
    <BaseList
      title="Genres"
      rows={genreList}
      deletePromise={deleteRow}
      columns={columns}
    />
  );
}

export default React.memo(GenreList);
